export const CALLS_TO_ACTION_NAV_ACCESS_SCOPE = 'calls-to-action-nav-access';
export const CALLS_TO_ACTION_READ_SCOPE = 'calls-to-action-read';
export const CALLS_TO_ACTION_PUBLISH_SCOPE = 'calls-to-action-publish';
export const CALLS_TO_ACTION_EDIT_SCOPE = 'calls-to-action-edit';
export const CTA_ACCESS_SCOPE = 'cta-access';
export const MESSAGING_ACCESS = 'messaging-access';